import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  createField,
  getForm,
  storeSetFieldsErrors,
  storeSetFieldValue
} from '../../../../../../utils/reducerHalpers/formFields';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_REQUEST_ADD_TO_EXECUTOR_LIST = 'SEND_REQUEST_ADD_TO_EXECUTOR_LIST';
const SEND_REQUEST_ADD_TO_CUSTOMER_LIST = 'SEND_REQUEST_ADD_TO_CUSTOMER_LIST';
const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';

const CHANGE_FIELD_CAUSES_ID = 'CHANGE_FIELD_CAUSES_ID';
const CHANGE_FIELD_BLOCKED_USER_ID = 'CHANGE_FIELD_BLOCKED_USER_ID';
const CHANGE_FIELD_COMMENT = 'CHANGE_FIELD_COMMENT';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      fields: {
        ...createField({
          field: 'causes_id',
          title: 'Причина',
          value: ''
        }),
        ...createField({
          field: 'blocked_user_id',
          title: 'Заблокированный пользователь',
          value: ''
        }),
        ...createField({
          field: 'comment',
          title: 'Комментарий',
          value: ''
        })
      }
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, SEND_REQUEST_ADD_TO_EXECUTOR_LIST):
        return setRequestStateInProgress(state);
      case createActionName(name, SEND_REQUEST_ADD_TO_CUSTOMER_LIST):
        return setRequestStateInProgress(state);
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state.merge({
          errors: {}
        });

      // FIELDS
      case createActionName(name, CHANGE_FIELD_CAUSES_ID): {
        return storeSetFieldValue(state, 'causes_id', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_BLOCKED_USER_ID): {
        return storeSetFieldValue(state, 'blocked_user_id', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_COMMENT): {
        return storeSetFieldValue(state, 'comment', action.payload);
      }
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});
export const requestFinished = (parentName, codeResponse, hasSuccess) => ({
  type: createActionName(parentName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendRequestToExecutorList = (parentName, payload) => ({
  type: createActionName(parentName, SEND_REQUEST_ADD_TO_EXECUTOR_LIST),
  payload
});
export const sendRequestAddToCustomerList = (parentName, payload) => ({
  type: createActionName(parentName, SEND_REQUEST_ADD_TO_CUSTOMER_LIST),
  payload
});
export const setErrors = (parentName, payload) => ({
  type: createActionName(parentName, SET_ERRORS),
  payload
});
export const clearAllErrors = (parentName, payload) => ({
  type: createActionName(parentName, CLEAR_ALL_ERRORS),
  payload
});

export const changeFieldCausesId = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_CAUSES_ID),
  payload
});
export const changeFieldBlockedUserId = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_BLOCKED_USER_ID),
  payload
});
export const changeFieldComment = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_COMMENT),
  payload
});

// SELECTORS
export const selectFormBody = (state, parentName) =>
  getForm(getState(state, parentName));
export const selectRequestState = (state, parentName) =>
  _.get(getState(state, parentName), 'requestState');
export const selectFieldCausesId = (state, parentName) =>
  _.get(getState(state, parentName), 'fields.causes_id');
export const selectFieldBlockedUserId = (state, parentName) =>
  _.get(getState(state, parentName), 'fields.blocked_user_id');
export const selectFieldComment = (state, parentName) =>
  _.get(getState(state, parentName), 'fields.comment');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/reducers/static/forms/addUserBlackListForm/reduce.js